import * as React from 'react';
import { SVGProps } from 'react';

const FileIconTiffSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width={24} height={28} rx={2} />
    <path
      opacity={0.6}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.5 14H6v6.667L9 18l6.5 6H18V14H6.5ZM6 23.5v-1.167l3-2.81L14 24H6v-.5Zm-1-9V25h14V13H5v1.5Zm8 3a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm1.5-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z"
      fill="#fff"
    />
    <path
      d="M10 3V2H9v1h1ZM8 4v1h1v3H8v1h3V8h-1V4H8ZM14.09 3.09a.374.374 0 0 1 .26-.09h1.15V2h-1.46c-.307 0-.557.1-.75.3-.193.193-.29.46-.29.8V4h-1v1h1v3h-1v1h3V8h-1V5h1V4h-1v-.7c0-.087.03-.157.09-.21ZM18.09 3.09a.374.374 0 0 1 .26-.09h1.15V2h-1.46c-.307 0-.557.1-.75.3-.193.193-.29.46-.29.8V4h-1v1h1v3h-1v1h3V8h-1V5h1V4h-1v-.7c0-.087.03-.157.09-.21ZM6.05 9c-.34 0-.6-.11-.78-.33C5.09 8.45 5 8.16 5 7.8V5H4V4h1V3h1v1h1v1H6v2.6c0 .147.037.25.11.31.073.06.187.09.34.09H7v1h-.95Z"
      fill="#fff"
    />
  </svg>
);
export default FileIconTiffSizeS;
